import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DataTablesResponse } from '../models/datatables';
import { ChangeOrderDTO } from '../models/change-order-dto';
import { PuntoapuntoLocalCampaignFilter, RenaultPuntoapuntoLocalCampaignCardDTO, RenaultPuntoapuntoLocalCampaignDTO } from '../models/renault-puntoapunto-local-campaign';

@Injectable({
  providedIn: 'root'
})

export class PuntoapuntoLocalCampaignService {

  private pathAPI = environment.urlAPI;
  private controller = "RenaultPuntoapuntoLocalCampaign/";

  constructor(private http: HttpClient) { }

  public get(id: string): Observable<RenaultPuntoapuntoLocalCampaignDTO> {
    return this.http.get<RenaultPuntoapuntoLocalCampaignDTO>(this.pathAPI + this.controller + id);
  }

  public getUserAvailable(data: PuntoapuntoLocalCampaignFilter): Observable<RenaultPuntoapuntoLocalCampaignCardDTO[]> {
    return this.http.post<RenaultPuntoapuntoLocalCampaignCardDTO[]>(this.pathAPI + this.controller + "GetUserAvailable", data);
  }

  public post(data: FormData): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller, data);
  }

  public put(id: string, data: FormData): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + id, data);
  }

  public changeStatus(id: string, idStatus: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatus/' + id + '/' + idStatus, null);
  }

  public changeNew(id: string, isNew: boolean): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeNew/' + id + '/' + isNew, null);
  }

  public changeOrderValidation(id: string, hasOrderValidation: boolean): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeOrderValidation/' + id + '/' + hasOrderValidation, null);
  }

  public changeOrder(data: ChangeOrderDTO[]): any {
    return this.http.post<any>(this.pathAPI + this.controller + 'ChangeOrder', data);
  }

  public getDataTable(data: any): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTable', data);
  }

  public getDataTableOrder(data: any): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTableOrder', data);
  }

  public deleteFile(id: string, type: string): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'DeleteFile/' + id + '/' + type, null);
  }

//   downloadLocalCampaignExcel(): Observable<Blob> {
//     let requestOptions: Object = {
//       responseType: 'blob'
//     }
//     let endpoint = this.pathAPI + this.controller + 'GetLocalCampaignExcel';
//     return this.http.get<Blob>(endpoint, requestOptions);
//   }

}
